import { AspectRatio, BackgroundImage, Badge, Box, Button, Card, Center, Chip, Container, Flex, Grid, Group, Image, Modal, Overlay, Stack, Text } from '@mantine/core';
import React, { useState } from 'react';
import ProjectContactForm from './ProjectContactForm';
import { Carousel } from '@mantine/carousel';
import { LightBox } from 'components/LightBox';

const ContentSpan = ({ content }: { content: string }) => {
    return (
        <Text component="span" size="sm" color="#15BC69">{content}</Text>
    )
}

const ProjectCard = ({ project }: { project: any }) => {
    const [opened, setOpened] = useState(false)
    const [showLightBox, setShowLightBox] = useState(false);
    const [clickedImage, setClickedImage] = useState(0);

    const handleOpenLightBox = (index: number) => {
        setClickedImage(index)
        setShowLightBox(true)
    }

    return (
        <>
            <Card
                withBorder
                radius={16}
                sx={{ cursor: 'pointer', height: '100%' }}
            >
                <Stack sx={{height: "100%"}} spacing={8}>
                    <Stack spacing={16}>
                        <BackgroundImage
                            src={project.bannerImageUrl}
                            sx={{ height: '150px', width: '100%', borderRadius: 8, backgroundSize: "100% auto", backgroundRepeat: "no-repeat" }}
                        >
                            <img src={project.bannerImageUrl} alt={project.title} className='sr-only' />
                        </BackgroundImage>
                        <AspectRatio ratio={693 / 878}>
                            <BackgroundImage
                                src={project.mainImageUrl}
                                sx={(theme) => (
                                    {
                                        height: '100%',
                                        width: '100%',
                                        borderRadius: 8,
                                        backgroundPosition: 'center',
                                        backgroundSize: "contain",
                                        backgroundRepeat: "no-repeat",
                                        backgroundColor: "rgba(0,0,0,1)",
                                        // [theme.fn.smallerThan("md")]: {
                                        //     height: '50vh',
                                        // }
                                    }
                                )}
                            >
                                <img src={project.mainImageUrl} alt={project.title} className='sr-only' />
                            </BackgroundImage>
                        </AspectRatio>
                    </Stack>
                    <Flex
                        sx={(theme) => ({
                            height: '100%',
                            gap: 16,
                            flexDirection: 'column',
                            // [theme.fn.smallerThan("md")]: {
                            // }
                        })}
                    >
                        <Stack spacing={16} sx={{ border: '1px solid #ddd', borderRadius: 8, padding: 16, flex: 1 }}>
                            {!project.comingSoon ? (
                                <>
                                    <Stack spacing={4}>
                                        <Text align='center' fz={36} component='h1' sx={{ lineHeight: 1, margin: 0, color: "#1F8150" }}>{project.title}</Text>
                                    </Stack>
                                    <article>
                                        <Text component='p' m={0}>{project.description}</Text>
                                    </article>
                                </>
                            ) : (
                                <>
                                    <Text align='center' fz={36} component='h1' sx={{ lineHeight: 1, margin: 0, color: "#1F8150" }}>{project.title}</Text>
                                    <Text align='center' fz={24}>Starting From <ContentSpan content="MYR" />{project.priceMax}</Text>
                                    <Text align='center'>This project is extremely new and we can't tell you too much information about it. </Text>
                                    <Text align='center'>Here are some of the things we can tell you</Text>
                                    <Stack spacing={4}>
                                        {project.shareData.map((d: string, i: number) => (
                                            <Text fz={14}>{i + 1}. {d}</Text>
                                        ))}
                                    </Stack>
                                </>
                            )}
                        </Stack>
                    </Flex>
                    <Stack spacing={8}>
                        {project.brochureLink && (
                            <Button
                                variant='outline'
                                onClick={() => window.open(project.brochureLink, '_blank')}
                            >
                                Download Brochure
                            </Button>
                        )}
                        <Button onClick={() => setOpened(true)}>Enquire</Button>
                    </Stack>
                </Stack>
            </Card>
            <Modal
                centered
                opened={opened}
                onClose={() => setOpened(false)}
                title={project.title}
            >
                <ProjectContactForm submitCallback={() => setOpened(false)} projectName={project.title} />
            </Modal>
            <LightBox
                showLightBox={showLightBox}
                onClose={() => setShowLightBox(false)}
                // image={formattedData.offerImages[0]?.src || ""}
                images={project.carousel}
                clickedImage={clickedImage}
            />
        </>
    );
};

export default ProjectCard;